function isUserName(userName) {
	var pPattern = /^[a-zA-Z\u4e00-\u9fa5]{0,10}$/;
	return pPattern.test(userName);
}
function isLoginUserName(userName) {
	var pPattern = /^[a-zA-Z0-9_]{0,10}$/;
	return pPattern.test(userName);
}
function isjtid(userName) {
	var pPattern = /^(?![0-9]+$)(?![A-Z]+$)[0-9A-Z]{8}$/;
	return pPattern.test(userName);
}

function isPassWord(password) {
	//	var pPattern = /^.*(?=.{6,})(?=.*\d)((?=.*[A-Z])|(?=.*[a-z])).*$/;
	var pPattern = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{0,16}$/;
	return pPattern.test(password);
}
function isAddress(userName) {
	var pPattern = /^[a-zA-Z0-9\u4e00-\u9fa5]{0,50}$/;
	return pPattern.test(userName);
}
function isRemarks(userName) {
	var pPattern = /^[a-zA-Z0-9\u4e00-\u9fa5]{0,200}$/;
	return pPattern.test(userName);
}
/**
 * 车牌号
 */
function isPlateNumber(plateNumber) {
	var pPattern = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,6}[A-Z0-9挂学警港澳]{1}$/;
	return pPattern.test(plateNumber);
}
/**
 * //验证手机号码
 */
export const isPhoneNumber = (hn) => {
	if(!(/^1[345678]\d{9}$/.test(hn))){
        return false;
    }
	return true;
}
/**
 * //验证场站编号
 */
export const isStationNumber = (hn) => {
	// if(!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{0,15}$/.test(hn))){
	if(!(/^[0-9]\d{0,20}$/.test(hn))){
        return false;
    }
	return true;
}

/**
 * 手机号明文替换成星号
 */
export const encryptPhoneNumber = (ph) => {
    return ph.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}
/**只能输入数字
 * @val retrun Boolean
 *
*/
export const isNumber = (hn) => {
	if(!(/^\d+$/.test(hn))){
        return false;
    }
	return true;
}
/**邮箱
 * @val retrun Boolean
 *
*/
export const isEmail = (hn) => {
	var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
	if(!(reg.test(hn))){
        return false;
    }
	return true;
}

/**
 * 证件号码
 */
// function isCardID(sId) {
export const isCard = (sId) => {
    var aCity = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"};
	var iSum = 0;
	var info = "";
	if(!/^\d{17}(\d|x)$/i.test(sId)) return "你输入的身份证长度或格式错误";
	sId = sId.replace(/x$/i, "a");
	if(aCity[parseInt(sId.substr(0, 2))] == null) return "你的身份证地区非法";
	sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
	var d = new Date(sBirthday.replace(/-/g, "/"));
	if(sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) return "身份证上的出生日期非法";
	for(var i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
	if(iSum % 11 != 1) return "你输入的身份证号非法";
	//aCity[parseInt(sId.substr(0,2))]+","+sBirthday+","+(sId.substr(16,1)%2?"男":"女");//此次还可以判断出输入的身份证号的人性别
	return true;
};
export const isCardID = (hn) => {
	// var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	var reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
	if(!(reg.test(hn))){
        return false;
    }
	return true;
}
export const isInteger = (hn) => {
	// var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	var reg = /^-?[0-9]\d*$/;
	if(!(reg.test(hn))){
        return false;
    }
	return true;
}
//小数点后保留两位
export const isTwoBits = (hn) => {
	// var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	var reg = /^\d+(\.\d{1,2})?$/;
	if(!(reg.test(hn))){
        return false;
    }
	return true;
}

window.isNumber = isNumber;
window.isCardID = isCardID;
window.isEmail = isEmail;
window.isInteger = isInteger;
window.isTwoBits = isTwoBits;
window.isUserName = isUserName;
window.isPassWord = isPassWord;
window.isPhoneNumber = isPhoneNumber;
window.isPlateNumber = isPlateNumber;
window.encryptPhoneNumber = encryptPhoneNumber;
window.isStationNumber = isStationNumber;
window.isLoginUserName = isLoginUserName;
window.isAddress = isAddress;
window.isRemarks = isRemarks;
window.isjtid = isjtid;
